import axios from 'axios';
import { get } from 'lodash';
import {
  FETCH_SITE_DATA,
  LOADING_MODE,
  HANDLE_ERRORS,
} from './types';
import BASE_URL from '../helpers/base-url';

import authorizeRequest from '../helpers/authorize-request';

export const getSiteData = () => async dispatch => {

  dispatch({ type: LOADING_MODE, payload: true });
  axios
    .all([
      // OLD battery data
      axios.get(`${BASE_URL}/api/external/battery/1`, authorizeRequest()),
      // NEW battery data
      axios.get(`${BASE_URL}/api/external/metric/14`, authorizeRequest()),
      // Generic Pmax data
      axios.get(`${BASE_URL}/api/external/metric/20`, authorizeRequest()),
      // Atypical Pmax on peak data
      axios.get(`${BASE_URL}/api/external/metric/21`, authorizeRequest()),
      // Atypical Pmax off peak data
      axios.get(`${BASE_URL}/api/external/metric/22`, authorizeRequest()),
      // meter without bess
      axios.get(`${BASE_URL}/api/external/setpoint/12`, authorizeRequest()),
      // Pmax load site w/o BESS (real)
      axios.get(`${BASE_URL}/api/external/metric/16`, authorizeRequest()),
      // Pmax load (real)
      axios.get(`${BASE_URL}/api/external/metric/17`, authorizeRequest()),
      // Setpoint
      axios.get(`${BASE_URL}/api/external/setpoint/11`, authorizeRequest())
    ])
    .then(
      axios.spread((
        battery,
        newBattery,
        pMax,
        pMaxOnPeak,
        pMaxOffPeak,
        meterWithoutBESS,
        pMaxLoadWithoutBess,
        pMaxLoad,
        setpoint
      ) => ({
        currentLoad: meterWithoutBESS.data.results[0].p,
        setpoint: setpoint.data.results[0].p,
        genericPmax: pMax.data.results[0].value,
        pMaxOnPeak: get(pMaxOnPeak, 'data.results[0].value'),
        pMaxOffPeak: get(pMaxOffPeak, 'data.results[0].value'),
        pMaxLoadWithoutBess: pMaxLoadWithoutBess.data.results[0].value,
        pMaxLoad: pMaxLoad.data.results[0].value,
        bessInstantPower: battery.data.results[0].p,
        bessStatus: battery.data.results[0].state,
        soc: battery.data.results[0].soc,
        soh: newBattery.data.results[0].value,
      }))
    )
    .then(payload => {
      dispatch({ type: FETCH_SITE_DATA, payload });
      dispatch({ type: LOADING_MODE, payload: false });
    })
    .then(() => {
      dispatch({
        type: HANDLE_ERRORS,
        payload: { message: "", open: false }
      });
    })
    .catch(error => {
      console.error(error);
      dispatch({
        type: HANDLE_ERRORS,
        payload: { message: error.message, open: true }
      });
      dispatch({ type: LOADING_MODE, payload: false });
    });
};


// WEBPACK FOOTER //
// ./src/actions/getSiteData.js